import {
  BillingTransactionStatus,
  BillingTransactionType,
} from "@/types/billing-transactions";

interface TransactionLike {
  type: string;
  status: string;
  amount: number;
  currency?: string;
}

export function computeBalanceStats(transactions: TransactionLike[]) {
  const currency = transactions[0]?.currency ?? "USD";

  const payments = transactions.filter(
    (tx) => tx.type === BillingTransactionType.PAYMENT,
  );

  const paidPayments = payments.filter(
    (tx) => tx.status === BillingTransactionStatus.SUCCEEDED,
  );

  const notPaidPayments = payments.filter(
    (tx) => tx.status !== BillingTransactionStatus.SUCCEEDED,
  );

  const creditMinor = paidPayments.reduce((sum, tx) => sum + tx.amount, 0);
  const debetMinor = notPaidPayments.reduce((sum, tx) => sum + tx.amount, 0);

  const balanceMinor = creditMinor - debetMinor;

  return {
    currency,
    debetMinor,
    creditMinor,
    balanceMinor,
  };
}

export function balanceMinorToMajor(balanceMinor: number): number {
  return balanceMinor / 100;
}

export function formatMoneyFromMinor(amountMinor: number, currency: string) {
  const value = amountMinor / 100;
  const s = value.toFixed(2);
  const trimmed = s.endsWith(".00") ? String(Math.trunc(value)) : s;
  return `${trimmed} ${currency}`;
}
